// HTML elements

export function getElement(id: string): HTMLElement | null {
  return (<HTMLElement>document.getElementById(id))
}

export function setElementClassName(id: string, className: string): boolean {
  let element=getElement(id)
  if(!element) return false

  element.classList.remove(className)
  element.classList.add(className)

  return true
}

export function setElementValidState(id: string, valid: boolean, invalidClassName: string='is-invalid'): boolean {
  let element=getElement(id)
  if(!element) return false

  element.classList.remove(invalidClassName);
  if(!valid) element.classList.add(invalidClassName);

  return true
}

// Input elements

export function getInput(id: string): HTMLInputElement | null {
  return (<HTMLInputElement>document.getElementById(id))
}

export function setInputValue(id: string, value: any): boolean {
  let element=getInput(id)
  if(!element) return false

  element.value=String(value)
  return true
}

export function setInputFocus(id: string, selectAll: boolean=true, delayInMilliseconds: number=0): boolean {
  if(!id) return false

  setTimeout( ()=> {
      let element=getInput(id)
      if(!element) return false

      element.focus()
      if(selectAll) element.select()

      return true
    }, delayInMilliseconds)

  return true
}

// Buttons

export function getButton(id: string): HTMLButtonElement | null {
  return (<HTMLButtonElement>document.getElementById(id))
}

export function clickOnButton(id: string): boolean {
  let element=getButton(id)
  if(!element) return false

  element.click()
  return true
}
